import apiClient from "./apiClient";

export const login = (credentials) =>
  apiClient.post("/api/Auth/login", credentials);

export const logout = () =>
  apiClient.post("/api/Auth/logout");

export const changePassword = (data) =>
  apiClient.post("/api/Auth/change-password", data);
